import { render, staticRenderFns } from "./modalAgendar.vue?vue&type=template&id=61b87580&"
import script from "./modalAgendar.vue?vue&type=script&lang=js&"
export * from "./modalAgendar.vue?vue&type=script&lang=js&"
import style0 from "./modalAgendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports